import { CalendarType, MonthPattern } from '@cbo/shared-library';

export const VALUATION_METHODS = {
  CURRENT_CASE_COST: 'Current Case Cost',
  DAILY_WEIGHTED_AVERAGE: 'Daily Weighted Average',
  MONTHLY_WEIGHTED_AVERAGE: 'Monthly Weighted Average',
} as const;

export const DEFAULT_DAYS_BACK = 90;
export const DEFAULT_CALENDAR_TYPE = CalendarType['12 months'];

export const DEFAULT_FORM_VALUES = {
  valuationMethod: VALUATION_METHODS.CURRENT_CASE_COST,
  daysBack: DEFAULT_DAYS_BACK,
  calendarType: DEFAULT_CALENDAR_TYPE,
  quarterStyle: MonthPattern['4-4-5'],
} as const;

export type ValuationMethod = (typeof VALUATION_METHODS)[keyof typeof VALUATION_METHODS];
